import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateBlog } from "../../api/apiBlogs";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

/**
 * Hook لتحديث مدونة
 */
export function useUpdateBlog() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: updateBlogMutate,
        isPending,
    } = useMutation({
        mutationFn: ({ id, data }) => updateBlog(id, data),
        onSuccess: (response) => {
            toast.success(response.message || "Updated successfully");
            queryClient.invalidateQueries({ queryKey: ["blogs"] });
            navigate('/blog');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update blog");
        },
    });

    return {
        updateBlogMutate,
        isPending,
    };
}
